<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
      Manage Employee Profile</h5>
  </div>
  <div id="mainContent" class="container">
    <div id="clientTable">
      <div class="row pt-4">
        <div class="col-md-6">
          <form (submit)="searchProfilesByName()" action="#">

            <div class="input-group mb-3">

              <!-- SEARCH INPUT -->
              <input type="text" class="form-control form-control-xs" [(ngModel)]="query"
                [ngModelOptions]="{ standalone: true }" placeholder="Search Employee" aria-label="Search Employee"
                aria-describedby="button-addon2" (ngModelChange)="searchNameClick()" />
              &nbsp;&nbsp;
              <!-- CHECKBOXES (MIDDLE SECTION) -->
              <div class="input-group-append d-flex align-items-center px-2">

                <label class="mr-2 mb-0">
                  <input type="checkbox" [(ngModel)]="activeSelected" [ngModelOptions]="{ standalone: true }" />
                  Active
                </label>

                <label class="mb-0">
                  <input type="checkbox" [(ngModel)]="closedSelected" [ngModelOptions]="{ standalone: true }" />
                  Closed
                </label>

              </div>
              &nbsp;&nbsp;
              <!-- SEARCH BUTTON -->
              <div class="input-group-append">
                <button class="btn btn-theme btn-xs" type="submit" id="button-addon2">
                  Search
                </button>
              </div>

            </div>

          </form>
        </div>

        <div class="col-md-4"></div>

        <div class="col-md-2">
          <button id="addProfileBtn" name="addProfileBtn" mat-raised-button class="btn-theme" style="float: right"
            matTooltip="Click to add employee" matTooltipPosition="left" (click)="onAddBtnClick()">
            <i class="fa fa-plus-square" aria-hidden="true"></i>
            &nbsp;&nbsp; Employee
          </button>
        </div>
      </div>
      <div class="row pt-2">
        <div class="col-md-12">
          <table class="table table-striped table-sm table-bordered">
            <thead class="">
              <tr>
                <th scope="col">Sr.No.</th>
                <th scope="col">Name</th>
                <th scope="col">Designation</th>
                <th scope="col">DOJ</th>
                <th scope="col">Status</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <!-- | search: 'firstName,lastName':query; -->
              <tr *ngFor="let formObj of employeeFormList; index as i" id="profile_{{ i + 1 }}">
                <td scope="row">{{ i + 1 }}</td>
                <td>
                  {{ formObj.firstName }} {{ formObj.middleName }}
                  {{ formObj.lastName }}
                </td>
                <td>
                  <span *ngIf="formObj.type == 'Article'; else show_designtion">
                    {{ formObj.type }}
                  </span>
                  <ng-template #show_designtion>{{
                    formObj.designation != null ? formObj.designation.name : ""
                    }}</ng-template>
                </td>
                <td>
                  <span *ngIf="formObj.userOfficialDetails">{{
                    formObj.userOfficialDetails.joiningDate | date: "dd-MMM-yyyy"
                    }}</span>
                </td>
                <td>
                  <span *ngIf="formObj.userOfficialDetails">{{
                    formObj.userOfficialDetails.profileStatus == true
                    ? "Active"
                    : "Closed"
                    }}</span>
                </td>
                <td>
                  <button id="viewProfileBtn_{{ i + 1 }}" name="viewProfileBtn_{{ i + 1 }}"
                    class="btn btn-sm btn-outline-theme" (click)="onViewClick(formObj)" matTooltip="Click to view"
                    matTooltipPosition="above">
                    <i class="fa fa-eye" aria-hidden="true"></i>
                  </button>
                  &nbsp;&nbsp;
                  <button id="editProfileBtn_{{ i + 1 }}" name="editProfileBtn_{{ i + 1 }}"
                    class="btn btn-sm btn-outline-theme" (click)="onEditClick(formObj)" matTooltip="Click to edit"
                    matTooltipPosition="above">
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </button>
                  &nbsp;&nbsp;
                  <button id="uploadUserPhotoBtn_{{ i + 1 }}" name="uploadUserPhotoBtn_{{ i + 1 }}"
                    class="btn btn-sm btn-outline-theme" (click)="onUploadUserDocumentClick(formObj)"
                    matTooltip="Click to upload user documents" matTooltipPosition="above">
                    <i class="fa fa-upload" aria-hidden="true"></i>
                  </button>
                  &nbsp;&nbsp;
                  <button id="viewUserDocumentsBtn_{{ i + 1 }}" name="viewUserDocumentsBtn_{{ i + 1 }}"
                    class="btn btn-sm btn-outline-theme" (click)="onViewUserDocumentsClick(formObj)"
                    matTooltip="Click to view user documents" matTooltipPosition="above">
                    <i class="fa fa-user-circle-o" aria-hidden="true"></i>
                  </button>
                  &nbsp;&nbsp;
                  <button id="deleteProfileBtn_{{ i + 1 }}" name="deleteProfileBtn_{{ i + 1 }}"
                    class="btn btn-sm btn-outline-danger" (click)="onDeleteClick(formObj)" matTooltip="Click to delete"
                    matTooltipPosition="above">
                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row pb-3">
        <div class="col-md-2">
          <button id="prevBtn" name="prevBtn" class="btn btn-sm btn-block btn-outline-theme"
            (click)="loadPreviousUsers()" [disabled]="page == 0" matTooltip="Click to load previous users"
            matTooltipPosition="above">
            <i class="fa fa-arrow-left" aria-hidden="true"></i> Previous
          </button>
        </div>
        <div class="col-md-8 text-muted" style="text-align: center; font-weight: bold">
          <span>Showing records for Page : {{ page + 1 }} , Records :
            {{ employeeFormList.length }}</span>
        </div>
        <div class="col-md-2">
          <button id="nextBtn" name="nextBtn" class="btn btn-sm btn-block btn-outline-theme" (click)="loadNextUsers()"
            matTooltip="Click to load next users" matTooltipPosition="above">
            Next <i class="fa fa-arrow-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #modalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">Employee</h5>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body pt-0" style="">
    <div class="row" style="">
      <div class="col-sm-6">
        <div class="row">
          <label for="approversName" class="col-sm-2 col-form-label">Type <span class="text-danger">*</span></label>
          <div class="col-sm-3">
            <select class="form-control form-control-xs mt-1" id="empType" name="empType" [(ngModel)]="empType"
              (change)="onChangeEmployeeType(); onQualificationsChange()">
              <option value="">Select Type</option>
              <option *ngFor="let empType of employeeTypeList" [value]="empType.name">
                {{ empType.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <!-- Employee Form Starts -->
    <form [formGroup]="employeeForm">
      <!-- {{employeeForm.invalid}} -->
      <!-- Employee Personal Details Starts -->
      <div class="row">
        <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
          <h6 class="card-subtitle">Employee Personal Details</h6>
        </div>
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="firstName" class="mb-0">First name <span class="text-danger">*</span></label>
                <input id="firstName" name="firstName" type="text" class="form-control form-control-xs"
                  formControlName="firstName" [class.is-invalid]="
                    employeeFormErrors.firstName && employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.firstName }}" matTooltipPosition="above" />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="middleName" class="mb-0">Middle name</label>
                <input id="middleName" name="middleName" type="text" class="form-control form-control-xs"
                  formControlName="middleName" [class.is-invalid]="
                    employeeFormErrors.middleName && employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.middleName }}" matTooltipPosition="above" />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="lastName" class="mb-0">Last name <span class="text-danger">*</span></label>
                <input id="lastName" name="lastName" type="text" class="form-control form-control-xs"
                  formControlName="lastName" [class.is-invalid]="
                    employeeFormErrors.lastName && employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.lastName }}" matTooltipPosition="above" />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="dateOfBirth" class="mb-0">Date Of Birth <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="dateOfBirth"
                    formControlName="dateOfBirth" ngbDatepicker #dateOfBirth="ngbDatepicker" [class.is-invalid]="
                      employeeFormErrors.dateOfBirth && employeeFormSubmitted
                    " matTooltip="{{ employeeFormErrors.dateOfBirth }}" matTooltipPosition="above" />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="dateOfBirth.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="bloodGroup" class="mb-0">Blood Group <span class="text-danger">*</span></label>
                <input id="bloodGroup" name="bloodGroup" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.bloodGroup }}" matTooltipPosition="above"
                  formControlName="bloodGroup" [class.is-invalid]="
                    employeeFormErrors.bloodGroup && employeeFormSubmitted
                  " />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="panNumber" class="mb-0">PAN Number <span class="text-danger">*</span></label>
                <input id="panNumber" name="panNumber" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.panNumber }}" matTooltipPosition="above" formControlName="panNumber"
                  [class.is-invalid]="
                    employeeFormErrors.panNumber && employeeFormSubmitted
                  " />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="aadharNumber" class="mb-0">Aadhar Number <span class="text-danger">*</span></label>
                <input id="aadharNumber" name="aadharNumber" type="number" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.aadharNumber }}" matTooltipPosition="above"
                  formControlName="aadharNumber" [class.is-invalid]="
                    employeeFormErrors.aadharNumber && employeeFormSubmitted
                  " />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0" *ngIf="empType == 'Article'">
                <label for="qualification" class="mb-0">Qualification <span class="text-danger">*</span></label>
                <input id="qualification" name="qualification" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.qualification }}" matTooltipPosition="above"
                  formControlName="qualification" [class.is-invalid]="
                    employeeFormErrors.qualification && employeeFormSubmitted
                  " />
              </div>
              <div class="form-group mb-0" *ngIf="empType != 'Article'">
                <mat-form-field appearance="legacy" style="width: 100%" [class.mat-form-field-invalid]="
                    employeeFormErrors.qualification &&
                    employeeFormSubmitted
                  ">
                  <mat-label>Qualification :</mat-label>
                  <mat-select formControlName="userQualifications" multiple [compareWith]="compareItems"
                    (selectionChange)="onQualificationsChange()">
                    >
                    <mat-option #item *ngFor="let qualification of qualificationList" [value]="qualification">
                      {{ qualification.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-sm-3" *ngIf="empType != 'Article'">
              <div class="form-group mb-0">
                <!-- <label for="certification" class="mb-0">Certification <span class="text-danger">*</span></label> -->
                <!-- <input id="certification" name="certification" type="text" class="form-control form-control-xs"
                                  matTooltip="{{employeeFormErrors.certification}}" matTooltipPosition="above"
                                  formControlName="certification" [class.is-invalid]="employeeFormErrors.certification && employeeFormSubmitted"> -->
                <mat-form-field appearance="legacy" style="width: 100%" [class.mat-form-field-invalid]="
                    employeeFormErrors.certificationType &&
                    employeeFormSubmitted
                  ">
                  <mat-label>Certification :</mat-label>
                  <mat-select formControlName="certificationType" multiple [compareWith]="compareItems">
                    <mat-option #item *ngFor="let certification of certificationList" [value]="certification"
                      (click)="checkSelection()">
                      {{ certification.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-3" *ngIf="showDescription">
              <div class="form-group mb-0">
                <label for="description" class="mb-0">Certification <span class="text-danger">*</span></label>
                <input id="description" name="description" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.description }}" matTooltipPosition="above"
                  formControlName="description" [class.is-invalid]="
                    employeeFormErrors.description && employeeFormSubmitted
                  " />
              </div>
            </div>
            <div class="col-sm-3">
              <label for="firstName" class="mb-0">Gender <span class="text-danger">*</span></label>
              <div class="form-group mb-0" style="margin-top: -2%">
                <div class="form-check form-check-inline" style="display: inline-block;">
                  <input class="form-check-input" type="radio" name="gender" id="gender1" [value]="'Male'"
                    formControlName="gender" />
                  <label class="col-form-label" style="font-weight: 400">Male</label>
                </div>
                <div class="form-check form-check-inline" style="display: inline-block;">
                  <input class="form-check-input" type="radio" name="gender" id="gender2" [value]="'Female'"
                    formControlName="gender" />
                  <label class="col-form-label" style="font-weight: 400">Female</label>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <label for="firstName" class="mb-0">Profile Status <span class="text-danger">*</span></label>
              <div class="form-group mb-0" style="margin-top: -2%">
                <div class="form-check form-check-inline" style="display: inline-block;">
                  <input class="form-check-input" type="radio" name="profileStatus" id="profileStatus1" [value]="true"
                    formControlName="profileStatus" (change)="profileStatusSelect()" />
                  <label class="col-form-label" style="font-weight: 400">Active</label>
                </div>
                <div class="form-check form-check-inline" style="display: inline-block;">
                  <input class="form-check-input" type="radio" name="profileStatus" id="profileStatus2" [value]="false"
                    formControlName="profileStatus" (change)="profileStatusSelect()" />
                  <label class="col-form-label" style="font-weight: 400">Closed</label>
                </div>
              </div>
            </div>
            <!-- <div class="col-sm-3">
                            <div class="form-group mb-0">
                              <label for="password" class="mb-0">Password <span class="text-danger">*</span></label>
                              <input id="password" name="password" type="password" class="form-control form-control-xs"
                              matTooltip="{{employeeFormErrors.password}}" matTooltipPosition="above"
                              formControlName="password" [class.is-invalid]="employeeFormErrors.password && employeeFormSubmitted">
                              </div>
                          </div> -->
          </div>
        </div>
      </div>
      <!-- Employee Personal Details Ends -->
      <!-- Employee Contact Details Starts -->
      <div class="row">
        <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
          <h6 class="card-subtitle">Employee Contact Details</h6>
        </div>
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="email" class="mb-0">Official Email ID <span class="text-danger">*</span></label>
                <input id="email" name="email" type="email" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.email }}" matTooltipPosition="above" formControlName="email"
                  [class.is-invalid]="
                    employeeFormErrors.email && employeeFormSubmitted
                  " />
              </div>
              <div class="form-group mb-0">
                <label for="personalEmail" class="mb-0">Personal Email ID <span class="text-danger">*</span></label>
                <input id="personalEmail" name="personalEmail" type="email" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.personalEmail }}" matTooltipPosition="above"
                  formControlName="personalEmail" [class.is-invalid]="
                    employeeFormErrors.personalEmail && employeeFormSubmitted
                  " />
              </div>
              <div class="form-group mb-0" *ngIf="empType != 'Article'">
                <label for="officalMobileNumber" class="mb-0">Official Mobile Number
                  <span class="text-danger">*</span></label>
                <input id="officalMobileNumber" name="officalMobileNumber" type="number"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.officalMobileNumber }}"
                  matTooltipPosition="above" formControlName="officalMobileNumber" [class.is-invalid]="
                    employeeFormErrors.officalMobileNumber &&
                    employeeFormSubmitted
                  " />
              </div>
              <div class="form-group mb-0">
                <label for="contactMobileNumber" class="mb-0">Personal Mobile Number.
                  <span class="text-danger">*</span></label>
                <input id="contactMobileNumber" name="contactMobileNumber" type="number"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.contactMobileNumber }}"
                  matTooltipPosition="above" formControlName="contactMobileNumber" [class.is-invalid]="
                    employeeFormErrors.contactMobileNumber &&
                    employeeFormSubmitted
                  " />
              </div>
              <!-- <div class="form-group mb-0">
                  <label for="landlineStdCode" class="mb-0">LandLine STD Code <span class="text-danger">*</span></label>
                  <input id="landlineStdCode" name="landlineStdCode" type="number" class="form-control form-control-xs"
                  matTooltip="{{employeeFormErrors.landlineStdCode}}" matTooltipPosition="above"
                  formControlName="landlineStdCode" [class.is-invalid]="employeeFormErrors.landlineStdCode && employeeFormSubmitted">
                  </div> -->
              <!-- <div class="form-group mb-0">
                  <label for="landlineNumber" class="mb-0">LandLine STD Number <span class="text-danger">*</span></label>
                  <input id="landlineNumber" name="landlineNumber" type="number" class="form-control form-control-xs"
                  matTooltip="{{employeeFormErrors.landlineNumber}}" matTooltipPosition="above"
                  formControlName="landlineNumber" [class.is-invalid]="employeeFormErrors.landlineNumber && employeeFormSubmitted">
                  </div> -->
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact Number 1
                  <span class="text-danger">*</span></label>
                <input id="emergencyContactNumber1" name="emergencyContactNumber1" type="number"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.emergencyContactNumber1 }}"
                  matTooltipPosition="above" formControlName="emergencyContactNumber1" [class.is-invalid]="
                    employeeFormErrors.emergencyContactNumber1 &&
                    employeeFormSubmitted
                  " />
              </div>
              <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact 1 Name
                  <span class="text-danger">*</span></label>
                <input id="emergencyContactName1" name="emergencyContactName1" type="text"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.emergencyContactName1 }}"
                  matTooltipPosition="above" formControlName="emergencyContactName1" [class.is-invalid]="
                    employeeFormErrors.emergencyContactName1 &&
                    employeeFormSubmitted
                  " />
              </div>
              <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact 1 Relation
                  <span class="text-danger">*</span></label>
                <input id="emergencyContactRelation1" name="emergencyContactRelation1" type="text"
                  class="form-control form-control-xs" matTooltip="{{
                    employeeFormErrors.emergencyContactRelation1
                  }}" matTooltipPosition="above" formControlName="emergencyContactRelation1" [class.is-invalid]="
                    employeeFormErrors.emergencyContactRelation1 &&
                    employeeFormSubmitted
                  " />
              </div>
              <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact Number 2
                  <span class="text-danger">*</span></label>
                <input id="emergencyContactNumber2" name="emergencyContactNumber2" type="number"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.emergencyContactNumber2 }}"
                  matTooltipPosition="above" formControlName="emergencyContactNumber2" [class.is-invalid]="
                    employeeFormErrors.emergencyContactNumber2 &&
                    employeeFormSubmitted
                  " />
              </div>
              <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact 2 Name
                  <span class="text-danger">*</span></label>
                <input id="emergencyContactName2" name="emergencyContactName2" type="text"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.emergencyContactName2 }}"
                  matTooltipPosition="above" formControlName="emergencyContactName2" [class.is-invalid]="
                    employeeFormErrors.emergencyContactName2 &&
                    employeeFormSubmitted
                  " />
              </div>
              <div class="form-group mb-0">
                <label for="" class="mb-0">Emergency Contact 2 Relation
                  <span class="text-danger">*</span></label>
                <input id="emergencyContactRelation2" name="emergencyContactRelation2" type="text"
                  class="form-control form-control-xs" matTooltip="{{
                    employeeFormErrors.emergencyContactRelation2
                  }}" matTooltipPosition="above" formControlName="emergencyContactRelation2" [class.is-invalid]="
                    employeeFormErrors.emergencyContactRelation2 &&
                    employeeFormSubmitted
                  " />
              </div>
            </div>
            <div class="col-sm-3" formGroupName="permanentAddress">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Permanent Address <span class="text-danger">*</span></label>
                <input id="permanentAddress" name="permanentAddress" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.address }}" matTooltipPosition="above" formControlName="address"
                  [class.is-invalid]="
                    employeeFormErrors.address &&
                    employeeForm.controls.permanentAddress.controls.address
                      .invalid &&
                    employeeFormSubmitted
                  " />
              </div>

              <div class="form-group mb-0">
                <label for="" class="mb-0">Permanent Street Name </label>
                <input id="permanentStreetName" name="permanentStreetName" type="text"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.streetName }}"
                  matTooltipPosition="above" formControlName="streetName" [class.is-invalid]="
                    employeeFormErrors.streetName &&
                    employeeForm.controls.permanentAddress.controls.streetName
                      .invalid &&
                    employeeFormSubmitted
                  " />
              </div>

              <div class="form-group mb-0">
                <label for="" class="mb-0">Permanent Address State
                  <span class="text-danger">*</span></label>

                <select class="form-control form-control-xs" id="permanentState" name="permanentState" type="text"
                  class="form-control form-control-xs" formControlName="state" (change)="
                    loadPermanantCities(
                      employeeForm.controls.permanentAddress.get('state').value
                    );
                   uncheckAddressCheckbox()" [class.is-invalid]="
                    employeeFormErrors.state &&
                    employeeForm.controls.permanentAddress.controls.state
                      .invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.state }}" matTooltipPosition="above">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let state of stateList" [ngValue]="state">
                    {{ state.name }}
                  </option>
                </select>
              </div>

              <div class="form-group mb-0">
                <label for="" class="mb-0">Permanent Address City
                  <span class="text-danger">*</span></label>
                <select *ngIf="modalStatus == 'add'" class="form-control form-control-xs" id="permanentCity"
                  name="permanentCity" type="text" class="form-control form-control-xs" formControlName="city" (change)="
                    loadPermanantPostcode(
                      employeeForm.controls.permanentAddress.get('city').value
                    );
                  uncheckAddressCheckbox()" [class.is-invalid]="
                    employeeFormErrors.city &&
                    employeeForm.controls.permanentAddress.controls.city
                      .invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.city }}" matTooltipPosition="above">
                  <option [value]="null">Select</option>
                  <option *ngFor="let city of permanentCityList" [ngValue]="city">
                    {{ city.name }}
                  </option>
                </select>

                <select *ngIf="modalStatus == 'edit' && showPermanentCity" class="form-control form-control-xs"
                  id="permanentCity" name="permanentCity" type="text" class="form-control form-control-xs"
                  formControlName="city" (change)="
                    loadPermanantPostcode(
                      employeeForm.controls.permanentAddress.get('city').value
                    );
                  uncheckAddressCheckbox()" [class.is-invalid]="
                    employeeFormErrors.city &&
                    employeeForm.controls.permanentAddress.controls.city
                      .invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.city }}" matTooltipPosition="above">
                  <option [value]="null">Select</option>
                  <option *ngFor="let city of permanentCityList" [ngValue]="city">
                    {{ city.name }}
                  </option>
                </select>

                <div *ngIf="modalStatus == 'edit' && !showPermanentCity" (click)="enablePermanentCity()"
                  matTooltip="'Click To Change'" matTooltipPosition="above" style="cursor: pointer">
                  <span *ngIf="this.employeeForm.value.permanentAddress.city">{{
                    this.employeeForm.value.permanentAddress.city.name
                    }}</span>
                </div>
                <!-- <input id="permanentCity" name="permanentCity" type="text" class="form-control form-control-xs"
                        matTooltip="{{employeeFormErrors.city}}" matTooltipPosition="above"
                        formControlName="city" [class.is-invalid]="employeeFormErrors.city && employeeForm.controls.permanentAddress.controls.city.invalid && employeeFormSubmitted"> -->
              </div>

              <div class="form-group mb-0">
                <label for="" class="mb-0">Permanent Address Pincode
                  <span class="text-danger">*</span></label>
                <select *ngIf="modalStatus == 'add'" class="form-control form-control-xs" id="permanentPostalCode"
                  name="permanentPostalCode" type="text" class="form-control form-control-xs"
                  formControlName="postalCode" (change)="uncheckAddressCheckbox()" [class.is-invalid]="
                    employeeFormErrors.postalCode &&
                    employeeForm.controls.permanentAddress.controls.postalCode
                      .invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.postalCode }}" matTooltipPosition="above">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let postCode of permanentPostcodeList" [ngValue]="postCode">
                    {{ postCode.name }}
                  </option>
                </select>

                <select *ngIf="modalStatus == 'edit' && showPermanentPostCode" class="form-control form-control-xs"
                  id="permanentPostalCode" name="permanentPostalCode" type="text" class="form-control form-control-xs"
                  formControlName="postalCode" (change)="uncheckAddressCheckbox()" [class.is-invalid]="
                    employeeFormErrors.postalCode &&
                    employeeForm.controls.permanentAddress.controls.postalCode
                      .invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.postalCode }}" matTooltipPosition="above">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let postCode of permanentPostcodeList" [ngValue]="postCode">
                    {{ postCode.name }}
                  </option>
                </select>

                <div *ngIf="modalStatus == 'edit' && !showPermanentPostCode" (click)="enablePermanentPostCode()"
                  matTooltip="'Click To Change'" matTooltipPosition="above" style="cursor: pointer">
                  <span *ngIf="this.employeeForm.value.permanentAddress.postalCode">{{
                    this.employeeForm.value.permanentAddress.postalCode.name
                    }}</span>
                </div>
              </div>
              <div class="form-group mb-0">
                <label for="" class="mb-0">Country <span class="text-danger">*</span></label>
                <input id="country1" name="country" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.country }}" matTooltipPosition="above" formControlName="country"
                  [class.is-invalid]="
                    employeeFormErrors.country &&
                    employeeForm.controls.permanentAddress.controls.country
                      .invalid &&
                    employeeFormSubmitted
                  " />
              </div>
            </div>


            <!-- <div class="form-check">
  <input type="checkbox" class="form-check-input" id="sameAsPermanent" [formControl]="employeeForm.get('sameAsPermanent')" (change)="onSameAsPermanentToggle()" />
  <label class="form-check-label" for="sameAsPermanent">Same as Permanent Address</label>
</div> -->


            <!-- <div class="col-sm-3" formGroupName="localAddress">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Local Address <span class="text-danger">*
                    
      <input
        type="checkbox"
        class="form-check-input me-1"
        id="sameAsPermanent"
        [formControl]="employeeForm.get('sameAsPermanent')"
        (change)="onSameAsPermanentToggle()" />
      <label class="form-check-label small" for="sameAsPermanent">
        Same as Permanent
      </label>
    
                </span></label>
                <input id="localAddress" name="localAddress" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.address }}" matTooltipPosition="above" formControlName="address"
                  [class.is-invalid]="
                    employeeFormErrors.address &&
                    employeeForm.controls.localAddress.controls.address
                      .invalid &&
                    employeeFormSubmitted
                  " />

                   
              </div>

              <div class="form-group mb-0">
                <label for="" class="mb-0">Local Street Name</label>
                <input id="localStreetName" name="localStreetName" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.streetName }}" matTooltipPosition="above"
                  formControlName="streetName" [class.is-invalid]="
                    employeeFormErrors.streetName &&
                    employeeForm.controls.localAddress.controls.streetName
                      .invalid &&
                    employeeFormSubmitted
                  " />
              </div>

              <div class="form-group mb-0">
                <label for="" class="mb-0">Local Address State <span class="text-danger">*</span></label>
                <select class="form-control form-control-xs" id="localState" name="localState" type="text"
                  class="form-control form-control-xs" formControlName="state" (change)="
                    loadLocalCities(
                      employeeForm.controls.localAddress.get('state').value
                    )
                  " [class.is-invalid]="
                    employeeFormErrors.state &&
                    employeeForm.controls.localAddress.controls.state.invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.state }}" matTooltipPosition="above">
                  <option [value]="null">Select</option>
                  <option *ngFor="let state of stateList" [ngValue]="state">
                    {{ state.name }}
                  </option>
                </select>
                <!-- <input id="state2" name="state" type="text" class="form-control form-control-xs"
                  matTooltip="{{employeeFormErrors.state}}" matTooltipPosition="above"
                  formControlName="state" [class.is-invalid]="employeeFormErrors.state && employeeForm.controls.localAddress.controls.state.invalid && employeeFormSubmitted"> -->
            <!-- </div> -->

            <!-- <div class="form-group mb-0">
                <label for="" class="mb-0">Local Address City <span class="text-danger">*</span></label>
                <select *ngIf="modalStatus == 'add'" class="form-control form-control-xs" id="localCity"
                  name="localCity" type="text" class="form-control form-control-xs" formControlName="city" (change)="
                    loadLocalPostcode(
                      employeeForm.controls.localAddress.get('city').value
                    )
                  " [class.is-invalid]="
                    employeeFormErrors.city &&
                    employeeForm.controls.localAddress.controls.city.invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.city }}" matTooltipPosition="above">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let city of localCityList" [ngValue]="city">
                    {{ city.name }}
                  </option>
                </select>

                <select *ngIf="modalStatus == 'edit' && showLocalCity" class="form-control form-control-xs"
                  id="localCity" name="localCity" type="text" class="form-control form-control-xs"
                  formControlName="city" (change)="
                    loadLocalPostcode(
                      employeeForm.controls.localAddress.get('city').value
                    )
                  " [class.is-invalid]="
                    employeeFormErrors.city &&
                    employeeForm.controls.localAddress.controls.city.invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.city }}" matTooltipPosition="above">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let city of localCityList" [ngValue]="city">
                    {{ city.name }}
                  </option>
                </select>

                <div *ngIf="modalStatus == 'edit' && !showLocalCity" (click)="enableLocalCity()"
                  matTooltip="'Click To Change'" matTooltipPosition="above" style="cursor: pointer">
                  <span *ngIf="this.employeeForm.getRawValue().localAddress.city">{{
                    this.employeeForm.getRawValue().localAddress.city.name
                    }}</span>
                </div>
              </div>

              <div class="form-group mb-0">
                <label for="" class="mb-0">Local Address Pincode
                  <span class="text-danger">*</span></label>
                <select *ngIf="modalStatus == 'add'" class="form-control form-control-xs" id="localPostalCode"
                  name="localPostalCode" type="text" class="form-control form-control-xs" formControlName="postalCode"
                  [class.is-invalid]="
                    employeeFormErrors.postalCode &&
                    employeeForm.controls.localAddress.controls.postalCode
                      .invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.postalCode }}" matTooltipPosition="above">
                  <option [value]="null">Select</option>
                  <option *ngFor="let postCode of localPostcodeList" [ngValue]="postCode">
                    {{ postCode.name }}
                  </option>
                </select>

                <select *ngIf="modalStatus == 'edit' && showLocalPostCode" class="form-control form-control-xs"
                  id="localPostalCode" name="localPostalCode" type="text" class="form-control form-control-xs"
                  formControlName="postalCode" [class.is-invalid]="
                    employeeFormErrors.postalCode &&
                    employeeForm.controls.localAddress.controls.postalCode
                      .invalid &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.postalCode }}" matTooltipPosition="above">
                  <option [value]="null">Select</option>
                  <option *ngFor="let postCode of localPostcodeList" [ngValue]="postCode">
                    {{ postCode.name }}
                  </option>
                </select>

                <div *ngIf="modalStatus == 'edit' && !showLocalPostCode" (click)="enableLocalPostCode()"
                  matTooltip="'Click To Change'" matTooltipPosition="above" style="cursor: pointer">
                  <span *ngIf="this.employeeForm.getRawValue().localAddress.postalCode">{{
                    this.employeeForm.getRawValue().localAddress.postalCode.name
                    }}</span>
                </div>
              </div>
              <div class="form-group mb-0">
                <label for="" class="mb-0">Country <span class="text-danger">*</span></label>
                <input id="localCountry" name="localCountry" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.country }}" matTooltipPosition="above" formControlName="country"
                  [class.is-invalid]="
                    employeeFormErrors.country &&
                    employeeForm.controls.localAddress.controls.country
                      .invalid &&
                    employeeFormSubmitted
                  " />
              </div>
            </div> -->
            <div class="col-sm-3" formGroupName="localAddress">
              <div class="form-group mb-0">
                <div class="d-flex align-items-center justify-content-between mb-1">
                  <label for="localAddress" class="mb-0">
                    Local Address <span class="text-danger">*</span>
                  </label>
                  <div class="form-check d-flex align-items-center mb-0">
                    <input type="checkbox" class="form-check-input me-1" id="sameAsPermanent"
                      [formControl]="employeeForm.get('sameAsPermanent')" (change)="onSameAsPermanentToggle()" />
                    <label class="form-check-label small" for="sameAsPermanent">
                      Same as Permanent
                    </label>
                  </div>
                </div>

                <input id="localAddress" name="localAddress" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.address }}" matTooltipPosition="above" formControlName="address"
                  [class.is-invalid]="
        employeeFormErrors.address &&
        employeeForm.controls.localAddress.controls.address.invalid &&
        employeeFormSubmitted
      " />
              </div>

              <!-- Local Street Name -->
              <div class="form-group mb-0">
                <label for="localStreetName" class="mb-0">Local Street Name</label>
                <input id="localStreetName" name="localStreetName" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.streetName }}" matTooltipPosition="above"
                  formControlName="streetName" [class.is-invalid]="
        employeeFormErrors.streetName &&
        employeeForm.controls.localAddress.controls.streetName.invalid &&
        employeeFormSubmitted
      " />
              </div>

              <!-- State -->
              <div class="form-group mb-0">
                <label for="localState" class="mb-0">Local Address State <span class="text-danger">*</span></label>
                <select class="form-control form-control-xs" id="localState" name="localState" formControlName="state"
                  (change)="loadLocalCities(employeeForm.controls.localAddress.get('state').value)" [class.is-invalid]="
        employeeFormErrors.state &&
        employeeForm.controls.localAddress.controls.state.invalid &&
        employeeFormSubmitted
      " matTooltip="{{ employeeFormErrors.state }}" matTooltipPosition="above">
                  <option [value]="null">Select</option>
                  <option *ngFor="let state of stateList" [ngValue]="state">
                    {{ state.name }}
                  </option>
                </select>
              </div>

              <!-- City -->
              <div class="form-group mb-0">
                <label for="localCity" class="mb-0">Local Address City <span class="text-danger">*</span></label>

                <!-- Add Mode -->
                <select *ngIf="modalStatus == 'add'" class="form-control form-control-xs" id="localCity"
                  name="localCity" formControlName="city"
                  (change)="loadLocalPostcode(employeeForm.controls.localAddress.get('city').value)" [class.is-invalid]="
        employeeFormErrors.city &&
        employeeForm.controls.localAddress.controls.city.invalid &&
        employeeFormSubmitted
      " matTooltip="{{ employeeFormErrors.city }}" matTooltipPosition="above">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let city of localCityList" [ngValue]="city">
                    {{ city.name }}
                  </option>
                </select>

                <!-- Edit Mode -->
                <select *ngIf="modalStatus == 'edit' && showLocalCity" class="form-control form-control-xs"
                  id="localCity" name="localCity" formControlName="city"
                  (change)="loadLocalPostcode(employeeForm.controls.localAddress.get('city').value)" [class.is-invalid]="
        employeeFormErrors.city &&
        employeeForm.controls.localAddress.controls.city.invalid &&
        employeeFormSubmitted
      " matTooltip="{{ employeeFormErrors.city }}" matTooltipPosition="above">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let city of localCityList" [ngValue]="city">
                    {{ city.name }}
                  </option>
                </select>

                <!-- Edit Static Display -->
                <div *ngIf="modalStatus == 'edit' && !showLocalCity" (click)="enableLocalCity()"
                  matTooltip="'Click To Change'" matTooltipPosition="above" style="cursor: pointer">
                  <span *ngIf="this.employeeForm.getRawValue().localAddress.city">
                    {{ this.employeeForm.getRawValue().localAddress.city.name }}
                  </span>
                </div>
              </div>

              <!-- Postal Code -->
              <div class="form-group mb-0">
                <label for="localPostalCode" class="mb-0">Local Address Pincode <span
                    class="text-danger">*</span></label>

                <!-- Add Mode -->
                <select *ngIf="modalStatus == 'add'" class="form-control form-control-xs" id="localPostalCode"
                  name="localPostalCode" formControlName="postalCode" [class.is-invalid]="
        employeeFormErrors.postalCode &&
        employeeForm.controls.localAddress.controls.postalCode.invalid &&
        employeeFormSubmitted
      " matTooltip="{{ employeeFormErrors.postalCode }}" matTooltipPosition="above">
                  <option [value]="null">Select</option>
                  <option *ngFor="let postCode of localPostcodeList" [ngValue]="postCode">
                    {{ postCode.name }}
                  </option>
                </select>

                <!-- Edit Mode -->
                <select *ngIf="modalStatus == 'edit' && showLocalPostCode" class="form-control form-control-xs"
                  id="localPostalCode" name="localPostalCode" formControlName="postalCode" [class.is-invalid]="
        employeeFormErrors.postalCode &&
        employeeForm.controls.localAddress.controls.postalCode.invalid &&
        employeeFormSubmitted
      " matTooltip="{{ employeeFormErrors.postalCode }}" matTooltipPosition="above">
                  <option [value]="null">Select</option>
                  <option *ngFor="let postCode of localPostcodeList" [ngValue]="postCode">
                    {{ postCode.name }}
                  </option>
                </select>

                <!-- Edit Static Display -->
                <div *ngIf="modalStatus == 'edit' && !showLocalPostCode" (click)="enableLocalPostCode()"
                  matTooltip="'Click To Change'" matTooltipPosition="above" style="cursor: pointer">
                  <span *ngIf="this.employeeForm.getRawValue().localAddress.postalCode">
                    {{ this.employeeForm.getRawValue().localAddress.postalCode.name }}
                  </span>
                </div>
              </div>

              <!-- Country -->
              <div class="form-group mb-0">
                <label for="localCountry" class="mb-0">Country <span class="text-danger">*</span></label>
                <input id="localCountry" name="localCountry" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.country }}" matTooltipPosition="above" formControlName="country"
                  [class.is-invalid]="
        employeeFormErrors.country &&
        employeeForm.controls.localAddress.controls.country.invalid &&
        employeeFormSubmitted
      " />
              </div>
            </div>

          </div>
        </div>
      </div>
      <!-- Employee Contact Details Ends -->
      <!-- Employee Official Details Starts -->
      <div class="row">
        <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
          <h6 class="card-subtitle">Employee Official Details</h6>
        </div>
        <div class="col-md-12">
          <div class="row mb-1">
            <div class="col-sm-3" *ngIf="empType == 'Article'">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Article Type <span class="text-danger">*</span></label>
                <select class="form-control form-control-xs" id="articleType" name="articleType"
                  matTooltip="{{ employeeFormErrors.articleType }}" matTooltipPosition="above"
                  (change)="onChangeArticleType()" formControlName="articleType" [class.is-invalid]="
                    employeeFormErrors.articleType && employeeFormSubmitted
                  ">
                  <option [value]="null">Select</option>
                  <option *ngFor="let articleType of articleTypeList" [value]="articleType.name">
                    {{ articleType.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3" *ngIf="
                empType == 'Article' ||
                empType == 'Consultant' ||
                empType == 'Employee'
              ">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Branch <span class="text-danger">*</span></label>
                <select class="form-control form-control-xs" id="branch" name="branch"
                  matTooltip="{{ employeeFormErrors.branch }}" matTooltipPosition="above" formControlName="branch"
                  [class.is-invalid]="
                    employeeFormErrors.branch && employeeFormSubmitted
                  ">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let branch of branchList" [ngValue]="branch">
                    {{ branch.name }}
                  </option>
                </select>
              </div>
            </div>

            <!-- <div class="col-sm-3" *ngIf="empType=='Article' || empType=='Consultant' || empType=='Employee'">
                    <div class="form-group mb-0">
                        <label for="" class="mb-0">Reporting Partner <span class="text-danger">*</span></label>
                        <select class="form-control form-control-xs" id="reportingPartner" name="reportingPartner"
                        matTooltip="{{employeeFormErrors.reportingPartner}}" matTooltipPosition="above"
                        formControlName="reportingPartner" [class.is-invalid]="employeeFormErrors.reportingPartner && employeeFormSubmitted">
                          <option [ngValue]="null">Select</option>
                          <option *ngFor="let partner of reportingPartnerList" [ngValue]="partner">{{partner.firstName}} {{partner.middleName}} {{partner.lastName}}</option>
                        </select>
                    </div>
                  </div> -->

            <div class="col-sm-3" *ngIf="
                empType == 'Article' &&
                !(employeeForm.value.articleType == 'Temporary')
              ">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Registered Partner <span class="text-danger">*</span></label>
                <select class="form-control form-control-xs" id="registeredPartner" name="registeredPartner"
                  matTooltip="{{ employeeFormErrors.registeredPartner }}" matTooltipPosition="above"
                  formControlName="registeredPartner" [class.is-invalid]="
                    employeeFormErrors.registeredPartner &&
                    employeeFormSubmitted
                  ">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let partner of registerPartnerList" [ngValue]="partner">
                    {{ partner.firstName }} {{ partner.middleName }}
                    {{ partner.lastName }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-3" *ngIf="
                empType == 'Article' ||
                empType == 'Consultant' ||
                empType == 'Employee'
              ">
              <div class="form-group mb-0">
                <label for="joiningDate" class="mb-0">Joining Date <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="joiningDate"
                    matTooltip="{{ employeeFormErrors.joiningDate }}" matTooltipPosition="above" ngbDatepicker
                    #joiningDate="ngbDatepicker" formControlName="joiningDate" (ngModelChange)="joiningDateChanged()"
                    [class.is-invalid]="
                      employeeFormErrors.joiningDate && employeeFormSubmitted
                    " (dateSelect)="setFromDateOfPartner()" />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="joiningDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3" *ngIf="
                empType == 'Article' &&
                !(employeeForm.value.articleType == 'Temporary')
              ">
              <div class="form-group mb-0">
                <label for="" class="mb-0">ICAI Registration Date
                  <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input id="icaiRegistrationDate" name="icaiRegistrationDate" class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy" ngbDatepicker matTooltip="{{ employeeFormErrors.icaiRegistrationDate }}"
                    matTooltipPosition="above" #icaiRegistrationDate="ngbDatepicker"
                    formControlName="icaiRegistrationDate" (ngModelChange)="ICAIRegDateChanged()" [placement]="'top'"
                    [class.is-invalid]="
                      employeeFormErrors.icaiRegistrationDate &&
                      employeeFormSubmitted
                    " />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="icaiRegistrationDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3" *ngIf="
                empType == 'Article' &&
                !(employeeForm.value.articleType == 'Temporary')
              ">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Articleship End Date
                  <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input id="articleshipEndDate" name="articleshipEndDate" class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy" ngbDatepicker matTooltip="{{ employeeFormErrors.articleshipEndDate }}"
                    matTooltipPosition="above" #articleshipEndDate="ngbDatepicker" formControlName="articleshipEndDate"
                    [placement]="'top'" [class.is-invalid]="
                      employeeFormErrors.articleshipEndDate &&
                      employeeFormSubmitted
                    " />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="articleshipEndDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-3" *ngIf="
                empType == 'Article' &&
                !(employeeForm.value.articleType == 'Temporary')
              ">
              <div class="form-group mb-0">
                <label class="mb-0">ICAI Registration Number
                  <span class="text-danger">*</span></label>
                <input id="icaiRegistrationNumber" name="icaiRegistrationNumber" type="text"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.icaiRegistrationNumber }}"
                  matTooltipPosition="above" formControlName="icaiRegistrationNumber" [class.is-invalid]="
                    employeeFormErrors.icaiRegistrationNumber &&
                    employeeFormSubmitted
                  " />
              </div>
            </div>
            <div class="col-sm-3" *ngIf="
                empType == 'Article' ||
                empType == 'Consultant' ||
                empType == 'Employee'
              ">
              <div class="form-group mb-0">
                <label class="mb-0">Laptop Service Tag Number
                  <span class="text-danger">*</span></label>
                <input id="laptopServiceTagNumber" name="laptopServiceTagNumber" type="text"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.laptopServiceTagNumber }}"
                  matTooltipPosition="above" formControlName="laptopServiceTagNumber" [class.is-invalid]="
                    employeeFormErrors.laptopServiceTagNumber &&
                    employeeFormSubmitted
                  " />
              </div>
            </div>
            <!-- <div class="col-sm-3" *ngIf="empType=='Article' || empType=='Consultant' || empType=='Employee'">
                  <div class="form-group mb-0">
                      <label class="mb-0">DataCard Number <span class="text-danger">*</span></label>
                      <input id="dataCardNumber" name="dataCardNumber" type="text" class="form-control form-control-xs"
                      matTooltip="{{employeeFormErrors.dataCardNumber}}" matTooltipPosition="above"
                      formControlName="dataCardNumber" [class.is-invalid]="employeeFormErrors.dataCardNumber && employeeFormSubmitted">
                  </div>
                  </div> -->
            <div class="col-sm-3" *ngIf="
                empType == 'Article' ||
                empType == 'Consultant' ||
                empType == 'Employee'
              ">
              <div class="form-group mb-0">
                <label class="mb-0">Bank Account Name And Branch
                  <span class="text-danger">*</span>
                </label>
                <select class="form-control form-control-xs" id="bankAcountName" name="bankAcountName"
                  matTooltip="{{ employeeFormErrors.bankAcountName }}" matTooltipPosition="above"
                  formControlName="bankAcountName" [class.is-invalid]="
                    employeeFormErrors.bankAcountName && employeeFormSubmitted
                  ">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let account of bankAccountList" [ngValue]="account.name">
                    {{ account.name }}
                  </option>
                </select>
                <!-- <input id="bankAcountName" name="bankAcountName" type="text" class="form-control form-control-xs"
                        matTooltip="{{employeeFormErrors.bankAcountName}}" matTooltipPosition="above"
                        formControlName="bankAcountName" [class.is-invalid]="employeeFormErrors.bankAcountName && employeeFormSubmitted"> -->
              </div>
            </div>

            <div class="col-sm-3" *ngIf="
                (empType == 'Article' ||
                  empType == 'Consultant' ||
                  empType == 'Employee') &&
                this.employeeForm.value.bankAcountName == 'Other Bank'
              ">
              <div class="form-group mb-0">
                <!-- matTooltip="{{employeeFormErrors.newBankAcountName}}" matTooltipPosition="above"
                      [class.is-invalid]="employeeFormErrors.newBankAcountName && employeeFormSubmitted"-->
                <label class="mb-0">Other Bank Account Name <span class="text-danger">*</span>
                </label>
                <input id="newBankAcountName" name="newBankAcountName" type="text" class="form-control form-control-xs"
                  formControlName="newBankAcountName" />
              </div>
            </div>

            <div class="col-sm-3" *ngIf="
                empType == 'Article' ||
                empType == 'Consultant' ||
                empType == 'Employee'
              ">
              <div class="form-group mb-0">
                <label class="mb-0">Bank Account Number <span class="text-danger">*</span></label>
                <input id="bankAccountNumber" name="bankAccountNumber" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.bankAccountNumber }}" matTooltipPosition="above"
                  formControlName="bankAccountNumber" [class.is-invalid]="
                    employeeFormErrors.bankAccountNumber &&
                    employeeFormSubmitted
                  " />
              </div>
            </div>

            <div class="col-sm-3" *ngIf="
                empType == 'Article' ||
                empType == 'Consultant' ||
                empType == 'Employee'
              ">
              <div class="form-group mb-0">
                <label class="mb-0">Bank IFSC Code</label>
                <input id="bankIfscCode" name="bankIfscCode" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.bankIfscCode }}" matTooltipPosition="above"
                  formControlName="bankIfscCode" [class.is-invalid]="
                    employeeFormErrors.bankIfscCode && employeeFormSubmitted
                  " />
              </div>
            </div>

            <div class="col-sm-3" *ngIf="empType == 'Consultant' || empType == 'Employee'">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Designation <span class="text-danger">*</span></label>
                <select class="form-control form-control-xs" id="designation" name="designation"
                  matTooltip="{{ employeeFormErrors.designation }}" matTooltipPosition="above"
                  formControlName="designation" [class.is-invalid]="
                    employeeFormErrors.designation && employeeFormSubmitted
                  ">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let designation of designationList" [ngValue]="designation">
                    {{ designation.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-3" *ngIf="empType == 'Consultant' || empType == 'Employee'">
              <div class="form-group mb-0">
                <!-- <label for="" class="mb-0">Role <span class="text-danger">*</span></label> -->
                <!-- <select class="form-control form-control-xs" id="droles" name="droles"
                      matTooltip="{{employeeFormErrors.droles}}" matTooltipPosition="above"
                      formControlName="droles" [class.is-invalid]="employeeFormErrors.droles && employeeFormSubmitted">
                        <option value="">Select</option>
                      </select> -->
                <label for="" class="mb-0">Role <span class="text-danger">*</span></label>
                <mat-form-field appearance="legacy" style="width: 100%" [class.mat-form-field-invalid]="
                    employeeFormErrors.droles && employeeFormSubmitted
                  ">
                  <!-- <mat-label>Role :</mat-label> -->
                  <mat-select formControlName="droles" id="droles" name="droles" multiple [compareWith]="compareItems"
                    (selectionChange)="onChange()">
                    <mat-option #item *ngFor="let droles of roleList" [value]="droles">
                      {{ droles.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="col-sm-3" *ngIf="empType == 'Consultant' || empType == 'Employee'">
              <div class="form-group mb-0">
                <label class="mb-0">Membership Number <span class="text-danger">*</span></label>
                <input id="membershipNumber" name="membershipNumber" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.membershipNumber }}" matTooltipPosition="above"
                  formControlName="membershipNumber" [class.is-invalid]="
                    employeeFormErrors.membershipNumber && employeeFormSubmitted" [ngStyle]="employeeForm.get('membershipNumber')?.disabled ? {
                            'background-color': '#e9ecef','color': '#6c757d','cursor': 'not-allowed'
                    } : {}" />
              </div>
            </div>

            <div class="col-sm-3" *ngIf="empType == 'Consultant' || empType == 'Employee'">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Membership Date<span class="text-danger">*</span></label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="dateOfMembershipNumber"
                    ngbDatepicker #dateOfMembershipNumber="ngbDatepicker" formControlName="dateOfMembershipNumber"
                    [placement]="'top'" [class.is-invalid]="
                      employeeFormErrors.dateOfMembershipNumber &&
                      employeeFormSubmitted
                    " />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs"
                      (click)="dateOfMembershipNumber.toggle()" type="button"></button>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-3" *ngIf="empType == 'Consultant' || empType == 'Employee'">
              <div class="form-group mb-0">
                <label class="mb-0">Probation Period <span class="text-danger">*</span></label>
                <input id="probabtionPeriod" name="probabtionPeriod" type="number" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.probabtionPeriod }}" matTooltipPosition="above"
                  (blur)="joiningDateChanged()" formControlName="probabtionPeriod" [class.is-invalid]="
                    employeeFormErrors.probabtionPeriod && employeeFormSubmitted
                  " />
              </div>
            </div>

            <!-- <div class="col-sm-3" *ngIf="empType=='Consultant' || empType=='Employee'">
                  <div class="form-group mb-0">
                  <label class="mb-0">No.Of Articles Eligible to be trained <span class="text-danger">*</span></label>
                  <input id="articleTrainingLimit" name="articleTrainingLimit" type="number" class="form-control form-control-xs"
                  matTooltip="{{employeeFormErrors.articleTrainingLimit}}" matTooltipPosition="above"
                  formControlName="articleTrainingLimit" [class.is-invalid]="employeeFormErrors.articleTrainingLimit && employeeFormSubmitted">
                  </div>
                  </div> -->
            <div class="col-sm-3" *ngIf="empType == 'Consultant' || empType == 'Employee'">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Background Verification Completed
                </label>
                <select class="form-control form-control-xs" id="verified" name="verified"
                  matTooltip="{{ employeeFormErrors.verified }}" matTooltipPosition="above" formControlName="verified"
                  [class.is-invalid]="
                    employeeFormErrors.verified && employeeFormSubmitted
                  ">
                  <option value="">Select</option>
                  <option *ngFor="let isDone of verficationDoneList" [value]="isDone.value">
                    {{ isDone.name }}
                  </option>
                </select>
              </div>
            </div>

            <div class="col-sm-3" *ngIf="empType == 'Consultant' || empType == 'Employee'">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Confirmation Date <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="confirmationDate"
                    ngbDatepicker matTooltip="{{ employeeFormErrors.confirmationDate }}" matTooltipPosition="above"
                    #confirmationDate="ngbDatepicker" formControlName="confirmationDate" [placement]="'top'"
                    [class.is-invalid]="
                      employeeFormErrors.confirmationDate &&
                      employeeFormSubmitted
                    " />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="confirmationDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3" *ngIf="empType == 'Consultant' || empType == 'Employee'">
              <div class="form-group mb-0">
                <label class="mb-0">Source Of Verification </label>
                <input id="verificationSource" name="verificationSource" type="text"
                  class="form-control form-control-xs" matTooltip="{{ employeeFormErrors.verificationSource }}"
                  matTooltipPosition="above" formControlName="verificationSource" [class.is-invalid]="
                    employeeFormErrors.verificationSource &&
                    employeeFormSubmitted
                  " />
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label class="mb-0">Remark <span class="text-danger">*</span></label>
                <input id="remark" name="remark" type="text" class="form-control form-control-xs"
                  matTooltip="{{ employeeFormErrors.remark }}" matTooltipPosition="above" formControlName="remark"
                  [class.is-invalid]="
                    employeeFormErrors.remark && employeeFormSubmitted
                  " />
              </div>
            </div>
            <div class="col-sm-3" *ngIf="
                (empType == 'Article' ||
                  empType == 'Consultant' ||
                  empType == 'Employee') &&
                !isPartner
              ">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Reporting Manager <span class="text-danger">*</span></label>
                <select class="form-control form-control-xs" id="reportingManager" name="reportingManager"
                  matTooltip="{{ employeeFormErrors.reportingManager }}" matTooltipPosition="above"
                  formControlName="reportingManager">
                  <option [ngValue]="null">Select</option>
                  <option *ngFor="let manager of reportingManagerList" [ngValue]="manager">
                    {{ manager.firstName }} {{ manager.middleName }}
                    {{ manager.lastName }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3" *ngIf=" empType == 'Employee'">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Commitment Date<span class="text-danger">*</span></label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="commitmentDate"
                    ngbDatepicker #commitmentDate="ngbDatepicker" formControlName="commitmentDate" [placement]="'top'"
                    [class.is-invalid]="
                    employeeFormErrors.commitmentDate &&
                    employeeFormSubmitted
                  " />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="commitmentDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>

            </div>
            <div class="col-sm-3" *ngIf="empType == 'Consultant' || empType == 'Employee'">
              <div class="form-group mb-0">
                <!-- <label for="qualification" class="mb-0"
                >Qualification <span class="text-danger">*</span></label
              >
              <input
                id="qualification"
                name="qualification"
                type="text"
                class="form-control form-control-xs"
                matTooltip="{{ employeeFormErrors.qualification }}"
                matTooltipPosition="above"
                formControlName="qualification"
                [class.is-invalid]="
                  employeeFormErrors.qualification && employeeFormSubmitted
                "
              /> -->
                <mat-form-field appearance="legacy" style="width: 100%" [class.mat-form-field-invalid]="
                  employeeFormErrors.serviceVerticle &&
                  employeeFormSubmitted
                ">
                  <mat-label>Service Vertical :</mat-label>
                  <mat-select formControlName="serviceVerticle" multiple [compareWith]="compareItems">
                    <mat-option #item *ngFor="let serviceVerticle of serviceVerticalList" [value]="serviceVerticle">
                      {{ serviceVerticle.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="col-sm-3" *ngIf="empType == 'Article'">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Scholarship</label>
                <input id="scholarship" name="scholarship" type="number" class="form-control form-control-xs"
                  matTooltipPosition="above" formControlName="scholarship" />
              </div>
            </div>

            <div class="col-sm-3" *ngIf="empType == 'Consultant'">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Clients <span class="text-danger">*</span></label>
                <mat-form-field appearance="legacy" style="width: 100%">
                  <!-- <mat-label>Clients :</mat-label> -->
                  <mat-select formControlName="clients" multiple [compareWith]="compareItems"
                    [class.mat-form-field-invalid]="
                      employeeFormErrors.clients && employeeFormSubmitted
                    ">
                    <mat-option [value]="" (click)="selectAllClient(clients)" #clients>Select All
                    </mat-option>
                    <mat-option #item *ngFor="let client of clientList" [value]="client">
                      {{ client.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row mb-1"></div>
          <div class="row mb-1"></div>
          <div class="row mb-1"></div>
          <div class="row mb-1">
            <div class="col-sm-3"></div>
            <div class="col-sm-3"></div>
          </div>
          <div class="row mb-1">
            <div class="col-sm-3"></div>
            <div class="col-sm-3"></div>
            <div class="col-sm-3"></div>
            <div class="col-sm-3"></div>
          </div>
        </div>
      </div>
      <!-- Employee Official Details Ends -->
      <div class="row pb-1" *ngIf="!isPartner">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3 card-header pb-1 pt-2 pr-1 pl-1">
              <h6 class="card-subtitle">Employee Reporting Partner</h6>
            </div>
            <div class="col-md-3 card-header pb-1 pt-1 pr-1 pl-1">
              <button type="button" class="btn btn-xs btn-theme" (click)="addPartnerButtonClick()">
                <i class="fa fa-plus-square-o" aria-hidden="true"></i> Partner
              </button>
            </div>
            <!-- <div class="col-md-8 card-header pb-1 pt-2 pr-1 pl-1"></div> -->
          </div>
        </div>

        <div class="col-md-12" formArrayName="reportingPartners" *ngFor="
            let partner of employeeForm.get('reportingPartners').controls;
            let i = index;
            let first = first
          ">
          <div class="row" [formGroupName]="i">
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label class="mb-0">Partner <span class="text-danger">*</span></label>
                <select class="form-control form-control-xs" [id]="'reportingPartner_' + i"
                  [name]="'reportingPartner_' + i" formControlName="reportingPartner" [class.is-invalid]="
                    partner.get('reportingPartner').errors?.required &&
                    employeeFormSubmitted
                  " matTooltip="{{ employeeFormErrors.reportingPartner }}" matTooltipPosition="above">
                  <option value="">Select</option>
                  <option *ngFor="let partner of reportingPartnerList" [ngValue]="partner">
                    {{ partner.firstName }} {{ partner.middleName }}
                    {{ partner.lastName }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="startDate" class="mb-0">From Date :</label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="startDate"
                    formControlName="startDate" ngbDatepicker #startDate="ngbDatepicker" (dateSelect)="getMaxDate(i)"
                    [minDate]="getMinDate(i)" [maxDate]="getMinDate(i)" matTooltip="{{ employeeFormErrors.startDate }}"
                    matTooltipPosition="above" [class.is-invalid]="
                      partner.get('startDate').errors?.required &&
                      employeeFormSubmitted
                    " />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="startDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label for="endDate" class="mb-0">To Date :</label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="endDate"
                    formControlName="endDate" ngbDatepicker #endDate="ngbDatepicker"
                    [minDate]="partner.get('startDate').value" matTooltip="{{ employeeFormErrors.endDate }}"
                    matTooltipPosition="above" [class.is-invalid]="
                      partner.get('endDate').errors?.required &&
                      employeeFormSubmitted
                    " />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="endDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1">
              <button type="button" *ngIf="!first" class="btn btn-sm btn-outline-danger mt-3"
                (click)="removePartnerButtonClick(i)">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- Employee CTC Details Starts -->
      <div class="row" *ngIf="empType != 'Article' && hasAccess('Employee CTC Details')">
        <!-- <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
          <h6 class="card-subtitle">Employee CTC Details</h6>
          </div> -->
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3 card-header pb-1 pt-2 pr-1 pl-1">
              <h6 class="card-subtitle">Employee CTC Details</h6>
            </div>
            <div class="col-md-1 card-header pb-1 pt-1 pr-1 pl-1">
              <button [disabled]="
                  !(
                    this.employeeForm.value.joiningDate &&
                    this.employeeForm.value.confirmationDate
                  )
                " type="button" class="btn btn-xs btn-theme" (click)="addCtcDetailsBtnClick()">
                <i class="fa fa-plus-square-o" aria-hidden="true"></i> CTC
              </button>

            </div>
            <div class="col-md-2 card-header pb-1 pt-2 pr-1 pl-1" style="text-align: right;">
              <span *ngIf="employeeFormErrors.userCtcDetails" style="color: red; font-size: 14px;">
                {{ employeeFormErrors.userCtcDetails }}
              </span>
            </div>
            <div class="col-md-6 card-header pb-1 pt-2 pr-1 pl-1"></div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-1" style="text-align: right">
              <label>Total CTC</label>
            </div>
            <div class="col-md-2">
              <label>From Date</label>
            </div>
            <div class="col-md-2">
              <label>To Date</label>
            </div>
            <div class="col-md-2">
              <label>Designation</label>
            </div>
          </div>
        </div>

        <div class="col-md-12" formArrayName="userCtcDetails" *ngFor="
            let userCtcDetail of employeeForm.get('userCtcDetails').controls;
            let i = index;
            let first = first
          ">
          <div class="row" [formGroupName]="i" *ngIf="userCtcDetail.value">
            <div class="col-sm-1" style="text-align: right">
              <div class="form-group mb-0">
                <!-- <label>{{
                  userCtcDetail.value.basic +
                  userCtcDetail.value?.childHostelAllowance +
                  userCtcDetail.value?.conveyanceAllowance +
                  userCtcDetail.value?.hra +
                  userCtcDetail.value?.medicalAllowance +
                  userCtcDetail.value?.esic +
                  userCtcDetail.value?.providentFund +
                  userCtcDetail.value?.mobileAllowance
                  }}</label> -->
                <label>{{ getTotalAmount(userCtcDetail.value) }}</label>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group mb-0">
                <label *ngIf="userCtcDetail.value.fromDate ">
                  {{getUserCTCFromDate(userCtcDetail)}}
                </label>

              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group mb-0">
                <label *ngIf="userCtcDetail.value.toDate">
                  {{getUserCTCToDate(userCtcDetail)}}
                </label>
              </div>
            </div>
            <div class="col-sm-2">
              <div class="form-group mb-0">
                <label *ngIf="userCtcDetail.value.designation">
                  <!-- {{userCtcDetail.value.toDate}} -->
                  {{ userCtcDetail.value.designation.name }}
                </label>
              </div>
            </div>
            <div class="col-md-2">
              <button type="button" class="btn btn-sm btn-outline-theme" (click)="editCtcInProfile(i)">
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
              </button>
              &nbsp;
              <button type="button" class="btn btn-sm btn-outline-danger" (click)="removeCtcFromProfile(i)">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <!-- <div class="col-md-12 card-header pb-1 pt-2 pr-1 pl-1">
            <h6 class="card-subtitle">Employee CTC Details</h6>
            </div> -->
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3 card-header pb-1 pt-2 pr-1 pl-1">
              <h6 class="card-subtitle">Employee Exit Details</h6>
            </div>
            <div class="col-md-3 card-header pb-1 pt-1 pr-1 pl-1">
              <button type="button" class="btn btn-xs btn-theme" (click)="toggleExitDetailsBtnClick()">
                <i class="fa fa-plus-square-o" aria-hidden="true"></i>&nbsp;&nbsp;
                <span *ngIf="!showEmployeeExitDetails">Show Exit Details</span>
                <span *ngIf="showEmployeeExitDetails">Hide Exit Details</span>
              </button>
            </div>
            <div class="col-md-6 card-header pb-1 pt-2 pr-1 pl-1"></div>
          </div>
        </div>

        <div class="col-md-12" *ngIf="showEmployeeExitDetails" formGroupName="userExitDetails">
          <div class="row">
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Exit Form <span class="text-danger">*</span></label>
                <input id="exitForm" name="exitForm" type="text" class="form-control form-control-xs"
                  formControlName="exitForm" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="exitDate" class="mb-0">Exit Date <span class="text-danger">*</span></label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="exitDate"
                    formControlName="exitDate" ngbDatepicker #exitDate="ngbDatepicker" [maxDate]="exitDateValidation" />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="exitDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Exit Reason <span class="text-danger">*</span></label>
                <input id="exitReason" name="exitReason" type="text" class="form-control form-control-xs"
                  formControlName="exitReason" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Data Card <span class="text-danger">*</span></label>
                <input id="dataCard" name="dataCard" type="text" class="form-control form-control-xs"
                  formControlName="dataCard" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Id Card<span class="text-danger">*</span></label>
                <input id="idCard" name="idCard" type="text" class="form-control form-control-xs"
                  formControlName="idCard" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Laptop <span class="text-danger">*</span></label>
                <input id="laptop" name="laptop" type="text" class="form-control form-control-xs"
                  formControlName="laptop" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Official Document <span class="text-danger">*</span></label>
                <input id="officialDocument" name="officialDocument" type="text" class="form-control form-control-xs"
                  formControlName="officialDocument" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Other Hardware <span class="text-danger">*</span></label>
                <input id="otherHardware" name="otherHardware" type="text" class="form-control form-control-xs"
                  formControlName="otherHardware" />
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Pen Drive<span class="text-danger">*</span></label>
                <input id="penDrvie" name="penDrvie" type="text" class="form-control form-control-xs"
                  formControlName="penDrvie" />
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group mb-0">
                <label for="" class="mb-0">Remark <span class="text-danger">*</span></label>
                <input id="remark" name="remark" type="text" class="form-control form-control-xs"
                  formControlName="remark" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Employee CTC Details Ends -->
    </form>
    <!-- Employee Form Ends -->
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-8"></div>
      <div class="col-sm-2">
        <button id="closeProfileBtn" name="closeProfileBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="closeModal()">
          Close
        </button>
      </div>
      <div class="col-sm-2">
        <button id="saveProfileBtn" name="saveProfileBtn" type="button" *ngIf="modalStatus == 'add'"
          class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">
          Save
        </button>
        <button id="updateProfileBtn" name="updateProfileBtn" type="button" *ngIf="modalStatus == 'edit'"
          class="btn btn-sm btn-block btn-outline-theme" (click)="onUpdateClick()">
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal Template -->
<ng-template #viewModalContent let-modalView>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">User Profile</h5>
    <!-- <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">
    <div class="row mb-1">
      <div class="col-sm-3"><label>Employee Name</label></div>
      <div class="col-sm-9">
        <label>:&nbsp;&nbsp;</label> {{ selectedEmployeeForView.firstName }}
        {{ selectedEmployeeForView.middleName }}
        {{ selectedEmployeeForView.lastName }}
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Partner In charge</label></div>
      <div class="col-sm-9">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userOfficialDetails">
          <span *ngIf="
              selectedEmployeeForView.userOfficialDetails.reportingPartners
                .length > 0
            ">
            {{viewCurrentReportPartner(selectedEmployeeForView.userOfficialDetails.reportingPartners)}}
            <!-- {{
              selectedEmployeeForView.userOfficialDetails.reportingPartners[0]
                .reportingPartner.firstName
            }}
            {{
              selectedEmployeeForView.userOfficialDetails.reportingPartners[0]
                .reportingPartner.middleName
            }}
            {{
              selectedEmployeeForView.userOfficialDetails.reportingPartners[0]
                .reportingPartner.lastName
            }} -->
          </span>
          <span *ngIf="
              selectedEmployeeForView.userOfficialDetails.reportingPartners
                .length == 0
            ">
            Self Apporved
          </span>
        </span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Designation :</label></div>
      <div class="col-sm-9">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="
            selectedEmployeeForView.type == 'Article';
            else show_designtion1
          ">
          {{ selectedEmployeeForView.type }}
        </span>
        <ng-template #show_designtion1>{{
          selectedEmployeeForView.designation.name
          }}</ng-template>
        <!-- <span *ngIf="selectedEmployeeForView.designation">{{selectedEmployeeForView.designation.name}}</span> -->
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Email</label></div>
      <div class="col-sm-9">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ selectedEmployeeForView.email }}</span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Personal Mobile No</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userPersonalDetails">{{
          selectedEmployeeForView.userPersonalDetails.contactMobileNumber
          }}</span>
      </div>
      <div class="col-sm-3"><label>Emergency Contact</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userPersonalDetails">{{
          selectedEmployeeForView.userPersonalDetails.emergencyContactNumber1
          }}</span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>PAN</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userPersonalDetails">{{
          selectedEmployeeForView.userPersonalDetails.panNumber
          }}</span>
      </div>
      <div class="col-sm-3"><label>Aadhar No</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userPersonalDetails">{{
          selectedEmployeeForView.userPersonalDetails.aadharNumber
          }}</span>
      </div>
    </div>
    <div class="row mb-1" *ngIf="onViewEmpType != 'Article'">
      <div class="col-sm-3"><label>Membership No</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userOfficialDetails">
          {{ selectedEmployeeForView.userOfficialDetails.membershipNumber }}
        </span>
      </div>
      <div class="col-sm-3" *ngIf="onViewEmpType != 'Article'">
        <label>Membership Date</label>
      </div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userOfficialDetails">{{
          selectedEmployeeForView.userOfficialDetails.dateOfMembershipNumber
          | date: "dd-MMM-yyyy"
          }}</span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>DOJ</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userOfficialDetails">{{
          selectedEmployeeForView.userOfficialDetails.joiningDate
          | date: "dd-MMM-yyyy"
          }}</span>
      </div>
      <div class="col-sm-3"><label>DOB</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userPersonalDetails">{{
          selectedEmployeeForView.userPersonalDetails.dateOfBirth
          | date: "dd-MMM-yyyy"
          }}</span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Blood Group</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userPersonalDetails">{{
          selectedEmployeeForView.userPersonalDetails.bloodGroup
          }}</span>
      </div>
      <div class="col-sm-3" *ngIf="hasAccess('Employee CTC Details')">
        <label>CTC Details</label>
      </div>
      <div class="col-sm-3" *ngIf="hasAccess('Employee CTC Details')">
        <label>:&nbsp;&nbsp;</label>
        <span>{{ userCTCDetails }}</span>
      </div>
    </div>
    <div class="row mb-1">
      <div class="col-sm-3"><label>Leave Balance</label></div>
      <div class="col-sm-3">
        <label>:&nbsp;&nbsp;</label>
        <span *ngIf="selectedEmployeeForView.userOfficialDetails">{{
          selectedEmployeeForView.type == 'Article'?"NA":selectedEmployeeForView.userOfficialDetails.pendingLeaves
          }}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-9"></div>
      <div class="col-sm-3">
        <button id="closeAssignmentBtn" name="closeAssignmentBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="modalView.dismiss('Cross click')">
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal Template -->
<ng-template #userProfileModalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">User Document Upload</h5>
  </div>
  <div class="modal-body">
    <div class="row col-md-12 mt-2" *ngFor="let document of userDocumentTypeList; let i = index">
      <div class="col-sm-4">
        <div *ngIf="document.required">
          <label>{{ document.type }}<span class="text-danger">*</span></label>
        </div>
        <div *ngIf="!document.required">
          <label>{{ document.type }}</label>
        </div>
      </div>
      <div class="col-sm-5" style="word-wrap: break-word">
        <input id="file" type="file" #myInput class="custome_file" (change)="fileChange($event, document)"
          placeholder="Upload file" accept=".jpg,.jpeg,.png,.pdf,.doc,.docx" />
      </div>
      <div class="col-sm-3" *ngIf="document.url != null">
        <a href="{{ document.url }}" target="_blank" rel="noopener noreferrer">
          <i class="fa fa-download fa-lg" aria-hidden="true"></i> </a>&nbsp;&nbsp; <span>{{ document.imageName }}</span>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
        <button id="closeAssignmentBtn" name="closeAssignmentBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">
          Close
        </button>
      </div>
      <div class="col-sm-3">
        <!-- <button id="saveAssignmentBtn" name="saveAssignmentBtn" type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button> -->
        <button id="updatePhotoBtn" name="updatePhotoBtn" type="button" class="btn btn-sm btn-block btn-outline-theme"
          (click)="onUploadClick()">
          Upload
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- Modal Template -->
<ng-template #userDocumentsModalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">User Documents</h5>
  </div>
  <div class="modal-body">
    <div class="row mt-2 col-md-12" *ngFor="let userDocument of userViewDocumentList">
      <div class="col-sm-4" *ngIf="userDocument.url != null">
        <label>{{ userDocument.type | titlecase }} </label>
      </div>
      <div class="col-sm-7" *ngIf="userDocument.url != null">
        <a [href]="userDocument.url" target="_blank" rel="noopener noreferrer">{{ userDocument.url }}</a>
      </div>
      <div class="col-sm-1" *ngIf="userDocument.url != null">
        <button _ngcontent-gwo-c331="" mattooltip="Click to delete" (click)="onDocDelete(userDocument)"
          mattooltipposition="above" class="btn btn-sm btn-outline-danger" ng-reflect-message="Click to delete"
          ng-reflect-position="above" id="deleteProfileBtn_5" name="deleteProfileBtn_5"
          aria-describedby="cdk-describedby-message-7" cdk-describedby-host="">
          <i _ngcontent-gwo-c331="" aria-hidden="true" class="fa fa-trash-o"></i>
        </button>
      </div>
    </div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-9"></div>
      <div class="col-sm-3">
        <button id="closeAssignmentBtn" name="closeAssignmentBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="modal.dismiss('Cross click')">
          Close
        </button>
      </div>
      <!-- <div class="col-sm-3"> -->
      <!-- <button id="saveAssignmentBtn" name="saveAssignmentBtn" type="button" *ngIf="modalStatus=='add'" class="btn btn-sm btn-block btn-outline-theme" (click)="onSaveClick()">Save</button> -->
      <!-- <button id="updatePhotoBtn" name="updatePhotoBtn" type="button" class="btn btn-sm btn-block btn-outline-theme" (click)="onUploadClick()">Update</button> -->
      <!-- </div> -->
    </div>
  </div>
</ng-template>

<!-- Modal Template -->
<ng-template #userCtcModalContent let-modal1>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title">User CTC Details</h5>
  </div>
  <div class="modal-body">
    <form [formGroup]="ctcForm">

      <div class="col-sm-12">
        <div class="row">
          <div class="col-sm-4">
            <label class="mb-0">EPF Applicable :</label>
            <select class="form-control form-control-xs mt-1" id="epfApplicable" name="epfApplicable"
              (change)="onEpfApplicableChange()" formControlName="epfApplicable"
              [class.is-invalid]="ctcFormErrors.epfApplicable && ctcFormSubmitted">
              <option [ngValue]="null">Select</option>
              <option [ngValue]="true">Yes</option>
              <option [ngValue]="false">No</option>
            </select>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Overtime Applicability : </label>
              <select class="form-control form-control-xs mt-1" id="overtimeApplicability" name="overtimeApplicability"
                matTooltipPosition="above" formControlName="overtimeApplicability" [compareWith]="compareItems"
                [class.is-invalid]="
                  ctcFormErrors.overtimeApplicability && ctcFormSubmitted
                ">
                <option [ngValue]=null>Select</option>
                <option *ngFor="let overtime of overtimeApplicabilityList" [ngValue]="overtime">
                  {{ overtime.name }}
                </option>
              </select>
              <!-- <input id="professionalExceptionMonth" name="professionalExceptionMonth" type="number" class="form-control form-control-xs"
              matTooltip="{{ctcFormErrors.professionalExceptionMonth}}" matTooltipPosition="above"
              formControlName="professionalExceptionMonth" [class.is-invalid]="ctcFormErrors.professionalExceptionMonth && ctcFormSubmitted"> -->
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Laptop Eligibility : </label>
              <select class="form-control form-control-xs mt-1" id="laptopEligibility" name="laptopEligibility"
                matTooltipPosition="above" formControlName="laptopEligibility" [class.is-invalid]="
                  ctcFormErrors.laptopEligibility && ctcFormSubmitted
                ">
                <option [ngValue]=null>Select</option>
                <option [ngValue]="true">Yes</option>
                <option [ngValue]="false">No</option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Designation :</label>
              <select class="form-control form-control-xs mt-1" id="designation" name="designation"
                (change)="onEpfApplicableChange()" matTooltipPosition="above" formControlName="designation"
                [class.is-invalid]="
                  ctcFormErrors.designation && ctcFormSubmitted
                ">
                <option value="">Select</option>
                <option *ngFor="let desig of designationList" [value]="desig.id">
                  {{ desig.name }}
                </option>
              </select>
              <!-- <select class="form-control form-control-xs" id="designation" name="designation"
                matTooltip="{{employeeFormErrors.designation}}" matTooltipPosition="above"
                formControlName="designation"
                [class.is-invalid]="ctcFormErrors.designation && ctcFormSubmitted">
                <option [ngValue]="null">Select</option>
                <option *ngFor="let designation of designationList" [value]="designation">{{ designation.name }}
                </option>
              </select> -->
            </div>
          </div>

        </div>
      </div>
      <br />



      <div class="col-md-12">
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">CTC : </label><span class="text-muted">Rs.</span>
              <input id="ctc" name="ctc" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.ctc }}" matTooltipPosition="above" formControlName="ctc"
                [class.is-invalid]="ctcFormErrors.ctc && ctcFormSubmitted" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Basic : </label><span class="text-muted">Rs.</span>
              <input id="basic" name="basic" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.basic }}" matTooltipPosition="above" formControlName="basic"
                [class.is-invalid]="ctcFormErrors.basic && ctcFormSubmitted" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">HRA : </label><span class="text-muted">Rs.</span>
              <input id="hra" name="hra" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.hra }}" matTooltipPosition="above" formControlName="hra"
                [class.is-invalid]="ctcFormErrors.hra && ctcFormSubmitted" />
            </div>
          </div>
          <!-- <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Mobile Allowance : </label><span class="text-muted">Rs.</span>
              <input id="mobileAllowance" name="mobileAllowance" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.mobileAllowance }}" matTooltipPosition="above"
                formControlName="mobileAllowance" [class.is-invalid]="
                  ctcFormErrors.mobileAllowance && ctcFormSubmitted
                " />
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Conveyance Allowance : </label>
              <input id="conveyanceAllowance" name="conveyanceAllowance" type="number"
                class="form-control form-control-xs" matTooltip="{{ ctcFormErrors.conveyanceAllowance }}"
                matTooltipPosition="above" formControlName="conveyanceAllowance" [class.is-invalid]="
                  ctcFormErrors.conveyanceAllowance && ctcFormSubmitted
                " />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Other Allowances : </label><span class="text-muted">Rs.</span>
              <input id="medicalAllowance" name="medicalAllowance" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.medicalAllowance }}" matTooltipPosition="above"
                formControlName="medicalAllowance" [class.is-invalid]="ctcFormErrors.basic && ctcFormSubmitted" />
            </div>
          </div>
          <!-- <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Education Allowance : </label><span class="text-muted">Rs.</span>
              <input id="educationAllowance" name="educationAllowance" type="number"
                class="form-control form-control-xs" matTooltip="{{ ctcFormErrors.educationAllowance }}"
                matTooltipPosition="above" formControlName="educationAllowance" [class.is-invalid]="
                  ctcFormErrors.educationAllowance && ctcFormSubmitted
                " />
            </div>
          </div> -->
          <div class="col-sm-4" *ngIf="ctcForm.get('mobileAllowance').value > 0">
            <div class="form-group mb-0">
              <label class="mb-0">Mobile Allowance : </label><span class="text-muted">Rs.</span>
              <input id="mobileAllowance" name="mobileAllowance" type="number" class="form-control form-control-xs"
                formControlName="mobileAllowance" />
            </div>
          </div>
          <!-- <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">ESIC : </label><span class="text-muted">Rs.</span>
              <input id="esic" name="esic" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.esic }}" matTooltipPosition="above" formControlName="esic"
                [class.is-invalid]="
                  ctcFormErrors.esic && ctcFormSubmitted
                " />
            </div>
          </div> -->
        </div>

        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Variable Component % : </label>
              <select class="form-control form-control-xs mt-1" id="variableComponentPercent"
                name="variableComponentPercent" matTooltipPosition="above" formControlName="variableComponentPercent"
                [class.is-invalid]="
                  ctcFormErrors.variableComponentPercent && ctcFormSubmitted
                ">
                <option [value]="0">NA</option>
                <option [value]="5">5%</option>
                <option [value]="7.5">7.5%</option>
                <option [value]="10">10%</option>
                <option [value]="12.5">12.5%</option>
                <option [value]="15">15%</option>
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Variable Component: </label><span class="text-muted">Rs.</span>
              <input id="variableComponent" name="variableComponent" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.variableComponent }}" matTooltipPosition="above"
                formControlName="variableComponent" [class.is-invalid]="
                  ctcFormErrors.variableComponent && ctcFormSubmitted
                " />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">ESIC : </label><span class="text-muted">Rs.</span>
              <input id="esic" name="esic" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.esic }}" matTooltipPosition="above" formControlName="esic"
                [class.is-invalid]="
                  ctcFormErrors.esic && ctcFormSubmitted
                " />
            </div>
          </div>
          <!-- <div class="col-sm-4" *ngIf="ctcForm.get('epfApplicable').value == true">
            <div class="form-group mb-0">
              <label for="uanNo" class="mb-0">UAN No.</label>
              <input id="uanNo" name="uanNo" type="number" class="form-control form-control-xs" formControlName="uanNo"
                (blur)="validateUanNumber()" [class.is-invalid]="
                    ctcFormErrors.uanNo && ctcFormSubmitted
                  " matTooltip="{{ ctcFormErrors.uanNo }}" matTooltipPosition="above" />
            </div>
          </div> -->
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Exgratia Month : </label>
              <select class="form-control form-control-xs mt-1" id="exgratiaMonth" name="exgratiaMonth"
                matTooltipPosition="above" formControlName="exgratiaMonth">
                <option value="">Select Month</option>
                <option *ngFor="let month of monthList" [value]="month.no">
                  {{ month.name }}
                </option>
              </select>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Performance Bonus : </label><span class="text-muted">Rs.</span>
              <input id="exgratia" name="exgratia" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.exgratia }}" matTooltipPosition="above" formControlName="exgratia"
                [class.is-invalid]="ctcFormErrors.basic && ctcFormSubmitted" />
            </div>
          </div>
          <div class="col-sm-4" *ngIf="ctcForm.get('epfApplicable').value == true">
            <div class="form-group mb-0">
              <label for="uanNo" class="mb-0">UAN No.</label>
              <input id="uanNo" name="uanNo" type="number" class="form-control form-control-xs" formControlName="uanNo"
                (blur)="validateUanNumber()" [class.is-invalid]="
                    ctcFormErrors.uanNo && ctcFormSubmitted
                  " matTooltip="{{ ctcFormErrors.uanNo }}" matTooltipPosition="above" />
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Prof Exception Month : </label>
              <select class="form-control form-control-xs mt-1" id="professionalExceptionMonth"
                name="professionalExceptionMonth" matTooltipPosition="above"
                formControlName="professionalExceptionMonth" [class.is-invalid]="
                  ctcFormErrors.professionalExceptionMonth && ctcFormSubmitted
                " (click)="onProfessionalExceptionMonthChange()">
                <option value="">Select Month</option>
                <option *ngFor="let month of monthList" [value]="month.no">
                  {{ month.name }}
                </option>
              </select>
              <!-- <input id="professionalExceptionMonth" name="professionalExceptionMonth" type="number" class="form-control form-control-xs"
              matTooltip="{{ctcFormErrors.professionalExceptionMonth}}" matTooltipPosition="above"
              formControlName="professionalExceptionMonth" [class.is-invalid]="ctcFormErrors.professionalExceptionMonth && ctcFormSubmitted"> -->
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Prof Exception Tax : </label><span class="text-muted">Rs.</span>
              <input id="professionalExceptionTax" name="professionalExceptionTax" type="number"
                class="form-control form-control-xs" matTooltipPosition="above" matTooltipPosition="above"
                formControlName="professionalExceptionTax" [class.is-invalid]="
                          ctcFormErrors.professionalExceptionTax && ctcFormSubmitted
                        " />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Prof Tax : </label><span class="text-muted">Rs.</span>
              <input id="professionalTax" name="professionalTax" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.professionalTax }}" matTooltipPosition="above"
                formControlName="professionalTax" [class.is-invalid]="
                          ctcFormErrors.professionalTax && ctcFormSubmitted
                        " />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Provident Fund : </label><span class="text-muted">Rs.</span>
              <input id="providentFund" name="providentFund" type="number" class="form-control form-control-xs"
                matTooltip="{{ ctcFormErrors.providentFund }}" matTooltipPosition="above"
                formControlName="providentFund" [class.is-invalid]="
                  ctcFormErrors.providentFund && ctcFormSubmitted
                " />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">CTC From Date : </label>
              <div class="input-group">
                <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="fromDate" ngbDatepicker
                  matTooltip="{{ ctcFormErrors.fromDate }}" matTooltipPosition="above" #fromDate="ngbDatepicker"
                  (dateSelect)="getMinToDateCtc()" formControlName="fromDate" [class.is-invalid]="
                    ctcFormErrors.fromDate && ctcFormSubmitted
                  " [placement]="'top'" />
                <div class="input-group-append">
                  <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="fromDate.toggle()"
                    type="button"></button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">CTC To Date : </label>
              <div class="input-group">
                <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="toDate" ngbDatepicker
                  #toDate="ngbDatepicker" [minDate]="minToCtcDate" matTooltip="{{ ctcFormErrors.toDate }}"
                  matTooltipPosition="above" formControlName="toDate"
                  [class.is-invalid]="ctcFormErrors.toDate && ctcFormSubmitted" [placement]="'top'" />
                <div class="input-group-append">
                  <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="toDate.toggle()"
                    type="button"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Security Deposit : </label><span class="text-muted">Rs.</span>
              <input id="securityDeposit" name="securityDeposit" type="number" class="form-control form-control-xs"
                matTooltipPosition="above" formControlName="securityDeposit" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Security From Date :</label>
              <div class="input-group">
                <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="securityFromDate"
                  ngbDatepicker matTooltipPosition="above" #securityFromDate="ngbDatepicker"
                  formControlName="securityFromDate" [placement]="'top'" />
                <div class="input-group-append">
                  <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="securityFromDate.toggle()"
                    type="button"></button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Security To Date : </label>
              <div class="input-group">
                <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="securityToDate" ngbDatepicker
                  #securityToDate="ngbDatepicker" matTooltipPosition="above" formControlName="securityToDate"
                  [placement]="'top'" />
                <div class="input-group-append">
                  <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="securityToDate.toggle()"
                    type="button"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Advance/Loan Details  -->
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Loan : </label><span class="text-muted">Rs.</span>
              <input id="loan" name="loan" type="number" class="form-control form-control-xs" matTooltipPosition="above"
                formControlName="loan" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">From Date :</label>
              <div class="input-group">
                <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="loanFromDate" ngbDatepicker
                  matTooltipPosition="above" #loanFromDate="ngbDatepicker" formControlName="loanFromDate"
                  [placement]="'top'" />
                <div class="input-group-append">
                  <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="loanFromDate.toggle()"
                    type="button"></button>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">To Date : </label>
              <div class="input-group">
                <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="loanToDate" ngbDatepicker
                  #loanToDate="ngbDatepicker" matTooltipPosition="above" formControlName="loanToDate"
                  [placement]="'top'" />
                <div class="input-group-append">
                  <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="loanToDate.toggle()"
                    type="button"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">EMI : </label><span class="text-muted">Rs.</span>
              <input id="emi" name="emi" type="number" class="form-control form-control-xs" matTooltipPosition="above"
                formControlName="emi" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Advance : </label><span class="text-muted">Rs.</span>
              <input id="advance" name="advance" type="number" class="form-control form-control-xs"
                matTooltipPosition="above" formControlName="advance" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Advance Month : </label>
              <select class="form-control form-control-xs mt-1" id="advanceMonth" name="advanceMonth"
                matTooltipPosition="above" formControlName="advanceMonth">
                <option [ngValue]="null">Select Month</option>
                <option *ngFor="let month of monthList" [ngValue]="month.no">
                  {{ month.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Recovery/Expenses : </label><span class="text-muted">Rs.</span>
              <input id="recoveryOrExpenses" name="recoveryOrExpenses" type="number"
                class="form-control form-control-xs" matTooltipPosition="above" formControlName="recoveryOrExpenses" />
            </div>
          </div>
          <div class="col-sm-4">
            <div class="form-group mb-0">
              <label class="mb-0">Recovery Month : </label>
              <select class="form-control form-control-xs mt-1" id="recoveryMonth" name="recoveryMonth"
                matTooltipPosition="above" formControlName="recoveryMonth">
                <option [ngValue]="null">Select Month</option>
                <option *ngFor="let month of monthList" [ngValue]="month.no">
                  {{ month.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-2 card-header pb-1 pt-2 pr-1 pl-1">
            <h6 class="card-subtitle">CTC TDS</h6>
          </div>
          <div class="col-md-2 card-header pb-1 pt-1 pr-1 pl-1">
            <button type="button" class="btn btn-xs btn-theme" (click)="addCtcTdsButtonClick()">
              <!-- [disabled]="
                !(this.ctcForm.value.fromDate && this.ctcForm.value.toDate)
              " -->
              <i class="fa fa-plus-square-o" aria-hidden="true"></i> TDS
            </button>
          </div>
          <div class="col-md-8 card-header pb-1 pt-2 pr-1 pl-1"></div>
        </div>
      </div>
      <div id="ctcDetail" *ngIf="ctcForm.value.userCtcTds.length > 0">
        <div class="col-md-12" formArrayName="userCtcTds" *ngFor="
            let ctcTds of ctcForm.get('userCtcTds').controls;
            let i = index;
            let first = first
          ">
          <div class="row" [formGroupName]="i">
            <div class="col-sm-3">
              <div class="form-group mb-0">
                <label class="mb-0">TDS : </label><span class="text-muted">Rs.</span>
                <input id="tds" name="tds" type="number" class="form-control form-control-xs" matTooltipPosition="above"
                  formControlName="tds" [class.is-invalid]="
                      ctcTds.get('tds').errors?.required &&
                      ctcFormSubmitted
                    " />
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="fromDate" class="mb-0">From Date :</label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="fromDate"
                    formControlName="fromDate" ngbDatepicker #fromDate="ngbDatepicker" [class.is-invalid]="
                      ctcTds.get('fromDate').errors?.required &&
                      ctcFormSubmitted
                    " />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="fromDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group mb-0">
                <label for="toDate" class="mb-0">To Date :</label>
                <div class="input-group">
                  <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="toDate"
                    formControlName="toDate" ngbDatepicker #toDate="ngbDatepicker"
                    [minDate]="ctcTds.get('fromDate').value" [class.is-invalid]="
                      ctcTds.get('toDate').errors?.required &&
                      ctcFormSubmitted
                    " />
                  <div class="input-group-append">
                    <button class="btn btn-outline-theme fa fa-calendar btn-xs" (click)="toDate.toggle()"
                      type="button"></button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-1">
              <button type="button" *ngIf="!first" class="btn btn-sm btn-outline-danger mt-3"
                (click)="removeCtcTdsButtonClick(i)">
                <i class="fa fa-times" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-6"></div>
      <div class="col-sm-3">
        <button id="closeAssignmentBtn" name="closeAssignmentBtn" type="button"
          class="btn btn-sm btn-block btn-outline-secondary" (click)="modal1.dismiss('Cross click')">
          Close
        </button>
      </div>
      <div class="col-sm-3">
        <button *ngIf="ctcModalStatus == 'add'" id="addCtcBtn" name="addCtcBtn" type="button"
          class="btn btn-sm btn-block btn-outline-theme" (click)="addCTCToProfile()">
          ADD
        </button>
        <button *ngIf="ctcModalStatus == 'edit'" id="updateCtcBtn" name="updateCtcBtn" type="button"
          class="btn btn-sm btn-block btn-outline-theme" (click)="updateCTCToProfile()">
          Update
        </button>
      </div>
    </div>
  </div>
</ng-template>